import API from './API.js'

export default class Discussions extends API {
  constructor() {
    super('discussions')
  }
}
